import React, { useState } from 'react';
import './VirtualCFO.css';

function InternationalBusiness() {
  const [activeIndex, setActiveIndex] = useState(null);

  const offerings = [
    {
      title: 'Cross-Border Setup',
      content: [
        'Incorporation of Indian subsidiaries for foreign entities',
        'Liaison, branch, and project office setup',
        'Outbound setup advisory for Indian companies',
        'Banking, PAN, GST, and other regulatory registrations'
      ]
    },
    {
      title: 'FEMA & RBI Compliance',
      content: [
        'Filing of FDI-related forms (FC-GPR, FC-TRS)',
        'Annual return on foreign liabilities and assets (FLA)',
        'ODI, ECB, and foreign remittance compliance',
        'Advisory on capital account transactions under FEMA'
      ]
    },
    {
      title: 'Tax & Transfer Pricing Advisory',
      content: [
        'International tax structuring',
        'Transfer pricing documentation & study reports',
        'Withholding tax calculation and filings',
        'DTAA planning and permanent establishment advisory'
      ]
    },
    {
      title: 'Investment & Expansion Support',
      content: [
        'Inbound and outbound investment advisory',
        'Joint venture structuring',
        'Global partner identification',
        'Compliance planning for international operations'
      ]
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/international_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>International Business Services</h1>
          <p>Navigate cross-border setups, FEMA compliance, and global expansion effortlessly</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Expand Across Borders with Confidence</h2>
          <p>We assist foreign entities entering India and Indian companies expanding overseas with regulatory, tax, and banking compliance.</p>
          <p>Our international support covers incorporation, RBI/FEMA filings, inbound and outbound investment advisory, and compliance planning.</p>
          <p>Work with experts who understand both Indian law and global business environments.</p>
        </div>
      </section>

      {/* Accordion Section */}
      <section className="accordion-section">
        <h2>Our Offerings</h2>
        <div className="accordion-container">
          {offerings.map((item, index) => (
            <div key={index} className={`accordion-item ${activeIndex === index ? 'active' : ''}`}>
              <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                <span>{activeIndex === index ? '−' : '+'}</span> {item.title}
              </div>
              {activeIndex === index && (
                <div className="accordion-body">
                  <ul>
                    {item.content.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default InternationalBusiness;


